var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacypolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.25H6M7.5 11.25H6M12 5.25H6M15 7.5V5.1C15 3.83988 15 3.20982 14.7548 2.72852C14.5391 2.30516 14.1949 1.96095 13.7715 1.74524C13.2901 1.5 12.6601 1.5 11.4 1.5H6.6C5.33988 1.5 4.70982 1.5 4.22852 1.74524C3.80516 1.96095 3.46095 2.30516 3.24524 2.72852C3 3.20982 3 3.83988 3 5.1V12.9C3 14.1602 3 14.7901 3.24524 15.2715C3.46095 15.6949 3.80516 16.0391 4.22852 16.2548C4.70982 16.5 5.33988 16.5 6.6 16.5H9.375M13.5 15.75C13.5 15.75 15.75 14.6776 15.75 13.0689V11.1922L14.1093 10.6059C13.7151 10.4647 13.284 10.4647 12.8898 10.6059L11.25 11.1922V13.0689C11.25 14.6776 13.5 15.75 13.5 15.75Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacypolicy);
export default __webpack_public_path__ + "static/media/privacypolicy.f5e225059715073a443e87320ab354ce.svg";
export { ForwardRef as ReactComponent };